import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Auth from '@shared/services/Auth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const SubjectTag = (props) => {

  const { subjects } = Auth.basics();
  const filteredSubjects = subjects.filter(subject => props.text === subject.name);
  let subject = filteredSubjects[0] !== undefined ? filteredSubjects[0] : null;

  if(['Documentaliste', 'Grand Oral'].includes(props.text)) {
    subject = {
      teacher_color: props.text === "Documentaliste" ? "6600a7" : "6600a7",
      name: props.text,
      font_awesome_class: props.text === "Documentaliste" ? "fa-glasses" : "fa-chalkboard-teacher",
    }
  }

  // Utiliser color_teacher (couleur enseignant) pour l'affichage
  const subjectColor = subject?.color_teacher || subject?.color;

  const useStyles = makeStyles((theme) => ({
    tag: {
      backgroundColor: subjectColor ? '#' + subjectColor : 'black',
      paddingTop: 2,
      paddingBottom: 2,
      paddingLeft: 10,
      paddingRight: 10,
      color: 'white',
      borderRadius: 3
    },
    icon: {
      marginRight: 10
    }
  }));

  const classes = useStyles();

  return (
    <span className={classes.tag}>
      {subject && subject.font_awesome_class &&
        <FontAwesomeIcon icon={"fa-solid " + subject.font_awesome_class} className={classes.icon} />
      }
      {props.text}
    </span>
  );
};
